const create = (entity) => `${entity}:create`;
const modify = (entity) => `${entity}:modify`;
const modifyId = (entity, id) => `${entity}:modify:${id}`;
const read = {
    item: (entity, id) => [modifyId(entity, id)],
    collection: (entity) => [modify(entity), create(entity)],
};
const write = {
    create: (entity) => [create(entity)],
    modify: (entity, id) => [
        modify(entity),
        modifyId(entity, id),
    ],
};
export default {
    read,
    write,
};
//# sourceMappingURL=keys.js.map